<div class="tcmodal" > 
  <!-- *ngIf="isAcceptTermsEnabled" -->
  <div class="modal-header">
    <h4 class="modal-title">Cloud-based Services Terms & Conditions</h4>
  </div>
  <div class="modal-body">

    <div class="terms-body">
      <h5>ELIWELL AIR WEB APPLICATION</h5>
      <p>Please read and accept our Terms & Conditions and Privacy Policy, you can find at the following links.</p>

      <p><a class="anchorempty" href="terms" rel="noopener noreferrer" target="_blank">Terms & Condition</a> </p>
      <p><a class="anchorempty" href="terms" rel="noopener noreferrer" target="_blank">Privacy Policy</a> </p>

    </div>

    <div class="qds-controls qds-related">
      <div class="qds-controls qds-related">
        <qds-label text="*Select Language:"></qds-label>
        <qds-select size="standard" style="width: 290px;" [value]="selectedLanguage" (qdsChange)="setLanguage($event)">
          
          <option *ngFor="let lang of languages" [value]="lang.code">{{ lang.name }}</option>
          
        </qds-select>
      </div>

    </div>
    <br>

    <div class="qds-controls">
      <div class="qds-controls qds-related">
          <qds-checkbox [(ngModel)]="termsandcondition" text="I agree with the Terms & Conditions."></qds-checkbox>
          <qds-checkbox [(ngModel)]="privacyandpolicy" text="I agree with the Privacy Policy."></qds-checkbox>
      </div>
    </div>  
    
  </div>
  <div class="modal-footer" style="display: flex; justify-content: flex-end; gap: 12px;">
    <qds-button  type="button" size="standard" importance="standard" text="Decline" (click)="DeclineTerms()"></qds-button>
    <qds-button size="standard" importance="emphasized" text="I Agree"  [disabled]="!termsandcondition || !privacyandpolicy || !languageSelected"
      (click)="AcceptTerms()"></qds-button>
  </div>
</div>

<!-- <div class="role-selection-modal" *ngIf="!isAcceptTermsEnabled">
  <div class="role-selection-container">
    <div class="role-selection-overlay">
      <div class="role-selection-header">
        <h1 class="role-selection-title">Please select your role:</h1>
      </div>
      <div class="role-cards-wrapper">
        <div class="role-card">
          <div class="role-card-content">
            <div class="role-icon">
              <div class="icon-placeholder">
                <qds-icon name="person" style="width: 46px; color: white;"></qds-icon>
              </div>
            </div>
            <h2 class="role-card-title">End User</h2>
            <p class="role-card-subtitle">Take full control of your cooling equipment — anytime, anywhere.</p>
            <div class="role-features">
              <p class="features-intro">With <strong>Silent Guardian</strong> and the <strong>AIR Edge WiFi</strong>,
                you can:</p>
              <div class="features-list">
                <div class="feature-item">
                  <div class="feature-icon">
                    <qds-radio checked size="small"></qds-radio>
                  </div>
                  <div class="feature-content">
                    <div class="feature-title">Stay informed:</div>
                    <div class="feature-description">Get instant email and smartphone alerts if something goes wrong.
                    </div>
                  </div>
                </div>
                <div class="feature-item">
                  <div class="feature-icon">
                    <span>
                      <qds-radio checked size="small"></qds-radio>
                    </span>
                  </div>
                  <div class="feature-content">
                    <div class="feature-title">Stay compliant:</div>
                    <div class="feature-description">Receive automatic temperature reports straight to your inbox</div>
                  </div>
                </div>
                <div class="feature-item">
                  <div class="feature-icon">
                    <qds-radio checked size="small"></qds-radio>
                  </div>
                  <div class="feature-content">
                    <div class="feature-title">Stay in control:</div>
                    <div class="feature-description">Adjust temperature setpoints remotely, from any device</div>
                  </div>
                </div>
                <div class="feature-item">
                  <div class="feature-icon">
                    <qds-radio checked size="small"></qds-radio>
                  </div>
                  <div class="feature-content">
                    <div class="feature-title">Stay supported:</div>
                    <div class="feature-description">Share access with your trusted technician for faster interventions
                      and reduced downtime.</div>
                  </div>
                </div>
              </div>
            </div>
            <p class="role-card-footer">Perfect for store managers, business owners, and anyone who needs peace of mind.
            </p>
            <qds-button size="standard" importance="emphasized" text="Select As End User" (click)="selectRole('EndUser')">Select As End User</qds-button>
          </div>
        </div>
        <div class="role-card">
          <div class="role-card-content">
            <div class="role-icon">
              <div class="icon-placeholder technician-icon">
                <qds-icon name="person-gear" style="width: 46px; color: white;"></qds-icon>
              </div>
            </div>
            <h2 class="role-card-title">Installer / Technician</h2>
            <p class="role-card-subtitle">Support your customers. Stay one step ahead.</p>
            <div class="role-features">
              <p class="features-intro">With access <strong>enabled by your end user,</strong> you can:</p>
              <div class="features-list">
                <div class="feature-item">
                  <div class="feature-icon">
                    <qds-radio checked size="small"></qds-radio>
                  </div>
                  <div class="feature-content">
                    <div class="feature-title">Set up alerts:</div>
                    <div class="feature-description">for your customer — and create your own private alerts to catch
                      early warning signs.</div>
                  </div>
                </div>
                <div class="feature-item">
                  <div class="feature-icon">
                    <qds-radio checked size="small"></qds-radio>
                  </div>
                  <div class="feature-content">
                    <div class="feature-title">Monitor remotely:</div>
                    <div class="feature-description">check temperatures and I/O status in real time</div>
                  </div>
                </div>
                <div class="feature-item">
                  <div class="feature-icon">
                    <qds-radio checked size="small"></qds-radio>
                    
                  </div>
                  <div class="feature-content">
                    <div class="feature-title">Automate reports:</div>
                    <div class="feature-description">for your customer — no manual work needed.</div>
                  </div>
                </div>
                <div class="feature-item">
                  <div class="feature-icon">
                    <qds-radio checked size="small"></qds-radio>
                  </div>
                  <div class="feature-content">
                    <div class="feature-title">Take full control:</div>
                    <div class="feature-description">Adjust settings, trigger defrosts and fine-tune the system from
                      anywhere.</div>
                  </div>
                </div>
              </div>
            </div>
            <p class="role-card-footer">Offer smarter service, without extra tools or subscriptions.</p>
            <qds-button size="standard" importance="emphasized" text="Select As Installer /
              Technician" (click)="selectRole('Installer')"></qds-button>  
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->